/* eslint-disable react/button-has-type */
/* eslint-disable global-require */
import React from 'react';
import Head from 'next/head';
// import Icon from '@material-ui/core/Icon';
import Button from '../../Components/Button';
import Accordion from '../../Components/AccordionLight';
import Article from '../../Components/Article';
import DigitalDisplay from '../../Components/DigitalDisplay';
import Navbar from '../../Components/Navbar';
import Footer from '../../Components/Footer';
import NavBarVertical from '../../Components/NavBarVertical';
import NavBarMobile from '../../Components/NavBarMobile';

class TestFormat extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    return (
      <React.Fragment>
        <Head>
          <title key="title">EDvice</title>
          <meta key="og:title" property="og:title" content="EDvice" />
          <meta key="description" name="description" content="EDvice" />
          <meta key="og:description" property="og:description" content="EDvice" />
        </Head>

        <Navbar>Navbar</Navbar>
        <div className="feature-exams">
          <DigitalDisplay
            color="red"
            image={require('./linguaskill_desktop.png')}
            column="col-xs-5"
          >
            <Article>
              <header className="exams__header" id="exams">
                <h2>
                  <strong>Information about the Linguaskill test</strong>
                </h2>
              </header>
            </Article>
          </DigitalDisplay>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-sm-4 col-xs-12 col-md-4 col-lg-4">
              <NavBarMobile />
              <NavBarVertical />
            </div>
            <div className="col-sm-8 col-xs-12 col-md-8 col-lg-8">
              <div className="test-format-content">
                <div className="section__one">
                  <h1>Test format and task types</h1>
                  <p>
                    Linguaskill is a modular online test which assesses all four language skills:
                    reading, listening, writing and speaking. This gives you choice about the skills
                    you want to assess.
                  </p>
                  <p>
                    Linguaskill is available as two options, General and Business. This gives you
                    the ability to choose the sort of language that will be tested, based on your
                    objectives.
                  </p>
                </div>
                <div className="section__two">
                  <h2>Linguaskill General</h2>
                  <p>
                    Linguaskill General tests language used in daily life, making it ideal for
                    university admission or exit, and recruitment for roles in a
                    non-business-specific environment. For example, where the employee needs strong
                    English skills to perform their role effectively, but will not need specialist
                    business terminology.
                  </p>
                  <p>
                    This makes the test suitable for a broad spectrum of organisations. Test topics
                    include studying and working, making future plans, travel and technology.
                  </p>
                </div>
                <div className="section__three">
                  <h2>Linguaskill Business</h2>
                  <p>
                    Linguaskill Business tests English used in a business and corporate setting, and
                    is most suitable for recruitment in organisations where employees are expected
                    to be familiar with the language of business.
                  </p>
                  <p>
                    It is suitable for large or small organisations, which may be operating on an
                    international level. Test topics include the buying and selling of products or
                    services, the office, business travel and human resources.
                  </p>
                  <div className="section__four">
                    <Accordion>
                      <div icon={require('./icon.png')} label="Reading and Listening">
                        <h2>Reading and Listening</h2>
                        <p>
                          The Reading and Listening module is adaptive, so there is not a fixed
                          number of questions. Each question the candidate answers helps the
                          computer to understand their level better. The test finishes when the
                          candidate has answered enough questions for Linguaskill to identify their
                          level accurately.
                        </p>
                        <div className="download">
                          <a href="https://www.cambridgeenglish.org/Images/466596-linguaskill-simplify-your-english-language-testing.pdf">
                            <img alt="test-format" src={require('./report04.png')} />
                            <div className="style-download">
                              <div className="__content">
                                <h3>
                                  Download our guide to computer adaptive testing of listening and
                                  reading skills.
                                </h3>
                              </div>
                              <div className="__footer">
                                <button className="download-button">Download now</button>
                              </div>
                            </div>
                          </a>
                        </div>
                        <table className="table__style">
                          <tbody>
                            <tr>
                              <td>Length:</td>
                              <td>About 60-80 minutes</td>
                            </tr>
                            <tr>
                              <td>Number of questions:</td>
                              <td>Variable</td>
                            </tr>
                            <tr>
                              <td>Types of questions – Reading tasks:</td>
                              <td>
                                <strong>Read and select</strong>
                                <br />
                                <p>
                                  Candidates read a notice, diagram, label, memo or letter
                                  containing a short text and choose the sentence or phrase that
                                  most closely matches the meaning of the text. There are three
                                  possible answers.
                                </p>
                                <strong>Gapped sentences</strong>
                                <br />
                                <p>
                                  Candidates read a sentence with a missing word (gap) and choose
                                  the correct word to fill the gap. There are four choices for each
                                  gap.
                                </p>
                                <strong>Multiple-choice gap-fill</strong>
                                <br />
                                <p>
                                  Candidates choose the right word or phrase to fill the gaps in a
                                  text. There are four choices for each gap.
                                </p>
                                <strong>Open gap-fill</strong>
                                <br />
                                <p>
                                  Candidates read a short text in which there are some missing words
                                  (gaps) and write in the missing word in each gap.
                                </p>
                                <strong>Extended reading</strong>
                                <br />
                                <p>
                                  Candidates read a longer text and answer a series of
                                  multiple-choice questions. The questions are in the same order as
                                  the information in the text.
                                </p>
                              </td>
                            </tr>
                            <tr>
                              <td>Types of questions – Listening tasks:</td>
                              <td>
                                <strong>Listen and select </strong>
                                <br />
                                <p>
                                  Candidates listen to a short audio recording and answer a
                                  multiple-choice question with three options.
                                </p>
                                <strong>Extended listening</strong>
                                <br />
                                <p>
                                  Candidates listen to a longer recording and answer a series of
                                  multiple-choice questions based on it. The questions are in the
                                  same order as the information they hear in the recording.
                                </p>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <div className="button-flex">
                          <Button
                            as="link"
                            color="red"
                            basic
                            onClick={() =>
                              'https://www.metritests.com/metricatestdelivery/Assessment/Assignment?test=LSKLDEMO02'
                            }
                          >
                            Take the Linguaskill General Reading and Listening sample test
                          </Button>
                          <Button
                            as="link"
                            color="red"
                            basic
                            onClick={() =>
                              'https://www.metritests.com/metricatestdelivery/Assessment/Assignment?test=LinguaskillBusinessDemo'
                            }
                          >
                            Take the Linguaskill Business Reading and Listening sample test
                          </Button>
                        </div>
                      </div>
                      <div icon={require('./icon1.png')} label="Writing">
                        <div label="Writing">
                          <h2>Writing</h2>
                          <p>
                            The Writing module asks candidates to input answers using a computer
                            keyboard. Answers are marked automatically by the computer. Results will
                            be available within 12 hours.
                          </p>
                          <table className="table__style">
                            <tbody>
                              <tr>
                                <td>Length:</td>
                                <td>45 minutes (2 parts)</td>
                              </tr>
                              <tr>
                                <td>Part 1 (Email) </td>
                                <td>The candidate will be asked to write a minimum of 50 words.</td>
                              </tr>
                              <tr>
                                <td>Marks in Part 1: </td>
                                <td>One half of the final Writing result.</td>
                              </tr>
                              <tr>
                                <td>Part 2 (Long text) </td>
                                <td>
                                  The candidate will be asked to write a minimum of 180 words.
                                </td>
                              </tr>
                              <tr>
                                <td>Marks in Part 2: </td>
                                <td>One half of the final Writing result.</td>
                              </tr>
                              <tr>
                                <td>Types of questions: </td>
                                <td>
                                  <strong>Part one</strong>
                                  <br />
                                  <p>
                                    Candidates read a short prompt, usually an email. They use the
                                    information in the prompt and the three bullet points to write
                                    an email of at least 50 words. Candidates should spend about 15
                                    minutes on this.
                                  </p>
                                  <strong>Part two</strong>
                                  <br />
                                  <p>
                                    Candidates read a short text outlining a scenario and respond
                                    using the information in the scenario and the three bullet
                                    points. Candidates will write a letter or a report of at least
                                    180 words. Candidates should spend about 30 minutes on this.
                                  </p>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <div className="button-flex">
                            <Button
                              as="link"
                              color="red"
                              basic
                              onClick={() =>
                                'https://www.metritests.com/metricatestdelivery/Assessment/Assignment?test=WritingDemoLinguaskill'
                              }
                            >
                              Take the Linguaskill General Writing sample test
                            </Button>
                            <Button
                              as="link"
                              color="red"
                              basic
                              onClick={() =>
                                'https://www.metritests.com/metricatestdelivery/Assessment/Assignment?test=WritingDemoLinguaskillBusiness'
                              }
                            >
                              Take the Linguaskill Business Writing sample test
                            </Button>
                          </div>
                        </div>
                      </div>
                      <div icon={require('./icon2.png')} label="Speaking">
                        <div label="Speaking">
                          <h2>Speaking</h2>
                          <p>
                            The Speaking module is taken using a computer with a microphone and
                            headphones. Questions are presented to the candidate through the
                            computer screen and headphones, and their responses are recorded and
                            assessed by examiners. Results will be available within 48 hours.
                          </p>
                          <strong>There are five parts to the Speaking module.</strong>
                          <table className="table__style">
                            <tbody>
                              <tr>
                                <td>Length:</td>
                                <td>15 minutes (5 parts)</td>
                              </tr>
                              <tr>
                                <td>Part 1 (interview) </td>
                                <td>
                                  The candidate answers eight questions about themselves (the first
                                  two questions are not marked).
                                </td>
                              </tr>
                              <tr>
                                <td>Questions: </td>
                                <td>8 </td>
                              </tr>
                              <tr>
                                <td>Marks in Part 1: </td>
                                <td>20% of the marks.</td>
                              </tr>
                              <tr>
                                <td>Part 2 (reading aloud) </td>
                                <td>The candidate reads eight sentences aloud.</td>
                              </tr>
                              <tr>
                                <td>Questions: </td>
                                <td>8</td>
                              </tr>
                              <tr>
                                <td>Marks in Part 2: </td>
                                <td>20% of the marks.</td>
                              </tr>
                              <tr>
                                <td>Questions: </td>
                                <td>8</td>
                              </tr>
                              <tr>
                                <td>Part 3 (long turn 1) </td>
                                <td>
                                  The candidate is given a topic to talk about for one minute. 40
                                  seconds are allowed for preparation.
                                </td>
                              </tr>
                              <tr>
                                <td>Questions: </td>
                                <td>1</td>
                              </tr>
                              <tr>
                                <td>Marks in Part 3: </td>
                                <td>20% of the marks.</td>
                              </tr>
                              <tr>
                                <td>Part 4 (long turn 2) </td>
                                <td>
                                  The candidate is given one or more graphics (for example a chart,
                                  diagram or information sheet) to talk about for one minute. One
                                  minute is allowed for preparation.
                                </td>
                              </tr>
                              <tr>
                                <td>Questions: </td>
                                <td>1</td>
                              </tr>
                              <tr>
                                <td>Marks in Part 4: </td>
                                <td>20% of the marks.</td>
                              </tr>
                              <tr>
                                <td>Part 5 (communication activity)</td>
                                <td>
                                  The candidate gives their opinions in the form of short responses
                                  to five questions related to one topic. One minute is allowed for
                                  preparation.
                                </td>
                              </tr>
                              <tr>
                                <td>Questions: </td>
                                <td>5</td>
                              </tr>
                              <tr>
                                <td>Marks in Part 5: </td>
                                <td>20% of the marks.</td>
                              </tr>
                            </tbody>
                          </table>
                          <div className="button-flex">
                            <Button
                              as="link"
                              color="red"
                              basic
                              onClick={() =>
                                'https://www.metritests.com/metricatestdelivery/Assessment/Assignment?test=SPEAKINGDEMO'
                              }
                            >
                              Take the Linguaskill General Speaking sample test
                            </Button>
                            <Button
                              as="link"
                              color="red"
                              basic
                              onClick={() =>
                                'https://www.metritests.com/metricatestdelivery/Assessment/Assignment?test=LinguaskillBusinessSpeakingSampleTest'
                              }
                            >
                              Take the Linguaskill Business Speaking sample test
                            </Button>
                          </div>
                        </div>
                      </div>
                    </Accordion>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </React.Fragment>
    );
  }
}
export default TestFormat;
